import { makeRequest } from "./api";

export const FetchBeds = async () => {
  return makeRequest("/api/admin/bed/fetch");
};

export const CreateBed = async (
  itemName,
  otherItemName,
  startValue,
  endValue
) => {
  return makeRequest("/api/admin/bed/create", {
    method: "POST",
    data: {
      itemName,
      otherItemName,
      startValue,
      endValue,
    },
  });
};

export const UpdateBed = async (
  itemName,
  otherItemName,
  startValue,
  endValue
) => {
  return makeRequest("/api/admin/bed/update", {
    method: "PUT",
    data: {
      itemName,
      otherItemName,
      startValue,
      endValue,
    },
  });
};

export const DeleteBed = async (houseTypeId) => {
  return makeRequest("/api/admin/bed/remove", {
    method: "DELETE",
    data: {
      data: {
        houseTypeId,
      },
    },
  });
};
